import { apiFetch } from '@/lib/api';

export interface CharacterDelta {
    add?: string[];
    remove?: string[];
}

export async function assignCharactersToAssets(
    showId: string,
    assets: any[],
    { add = [], remove = [] }: CharacterDelta,
): Promise<any[]> {
    const assetIds = assets.map((asset: any) => asset._id);

    const response = await apiFetch(`/api/shows/${showId}/assets/characters`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ assetIds, add, remove }),
    });

    if (!response.ok) throw new Error('Failed to update asset characters');

    return response.json();
}
